/** Triggers encouraging feedback when all today tasks are completed. */
import { useState, useEffect, useRef } from 'react';
import { getCurrentLocale } from '@/i18n/useT';
import { nl as nlPhrases, en as enPhrases } from '@/i18n/celebrationPhrases';

const PHRASES_BY_LOCALE = { nl: nlPhrases, en: enPhrases };

function getPhrases() {
  return PHRASES_BY_LOCALE[getCurrentLocale()] || nlPhrases;
}

export const useCelebration = (
  _allTasks,
  _activeFocusTaskId,
  todayTasks,
  hasActiveFilter = false,
) => {
  const [celebrationOpen, setCelebrationOpen] = useState(false);
  const [celebrationMessage, setCelebrationMessage] = useState('');
  const prevTodayCountRef = useRef(0);

  useEffect(() => {
    if (
      prevTodayCountRef.current > 0 &&
      todayTasks.length === 0 &&
      !hasActiveFilter
    ) {
      const { allDonePhrases } = getPhrases();
      setCelebrationMessage(
        allDonePhrases[Math.floor(Math.random() * allDonePhrases.length)],
      );
      setCelebrationOpen(true);
    }
    prevTodayCountRef.current = todayTasks.length;
  }, [todayTasks.length, hasActiveFilter]);

  const handleCloseCelebration = (event, reason) => {
    if (reason === 'clickaway') return;
    setCelebrationOpen(false);
  };

  return {
    celebrationOpen,
    celebrationMessage,
    handleCloseCelebration,
  };
};
